/**
 * DO NOT MANUALLY EDIT THIS FILE
 * This file is generated automatically by the build script on prebuild step.
 * Please refer to documentation for more information
 */

export default function CmsPages({ children }) {
  return children({
    '/de/kontakt': { id: 133, localeCode: 'de-DE' },
    '/contact': { id: 133, localeCode: 'en-GB' },
    '/fr/contactez-nous': { id: 133, localeCode: 'fr-FR' },
    '/de/rechtliches': { id: 134, localeCode: 'de-DE' },
    '/legal': { id: 134, localeCode: 'en-GB' },
    '/fr/legal': { id: 134, localeCode: 'fr-FR' },
    '/de/kunstberatung': { id: 135, localeCode: 'de-DE' },
    '/talk-to-curator': { id: 135, localeCode: 'en-GB' },
    '/fr/service-art-advisory': { id: 135, localeCode: 'fr-FR' },
    '/de/datenschutzerklaerung': { id: 136, localeCode: 'de-DE' },
    '/privacy': { id: 136, localeCode: 'en-GB' },
    '/fr/confidentialite': { id: 136, localeCode: 'fr-FR' },
    '/de/geschaeftsbedingungen': { id: 137, localeCode: 'de-DE' },
    '/terms/general': { id: 137, localeCode: 'en-GB' },
    '/fr/conditions/general': { id: 137, localeCode: 'fr-FR' },
    '/de/einreichungsbedingungen': { id: 138, localeCode: 'de-DE' },
    '/terms/submission': { id: 138, localeCode: 'en-GB' },
    '/fr/conditions/soumission': { id: 138, localeCode: 'fr-FR' },
    '/de/geschenkkarten': { id: 139, localeCode: 'de-DE' },
    '/gift': { id: 139, localeCode: 'en-GB' },
    '/fr/cartes-cadeaux': { id: 139, localeCode: 'fr-FR' },
    '/de/black-friday': { id: 140, localeCode: 'de-DE' },
    '/black-friday': { id: 140, localeCode: 'en-GB' },
    '/fr/black-friday': { id: 140, localeCode: 'fr-FR' },
    '/de/weihnachten': { id: 141, localeCode: 'de-DE' },
    '/christmas': { id: 141, localeCode: 'en-GB' },
    '/fr/noel': { id: 141, localeCode: 'fr-FR' },
    '/de/ueber-uns': { id: 142, localeCode: 'de-DE' },
    '/about-us': { id: 142, localeCode: 'en-GB' },
    '/fr/a-propos': { id: 142, localeCode: 'fr-FR' },
    '/de/kunst-fuers-buero': { id: 143, localeCode: 'de-DE' },
    '/art-for-the-office': { id: 143, localeCode: 'en-GB' },
    '/fr/pour-les-entreprises': { id: 143, localeCode: 'fr-FR' },
    '/de/kunst-fuer-innenarchitekten': { id: 144, localeCode: 'de-DE' },
    '/art-for-interior-designers': { id: 144, localeCode: 'en-GB' },
    '/fr/pour-les-decorateurs': { id: 144, localeCode: 'fr-FR' },
    '/de/uber/vermietung': { id: 145, localeCode: 'de-DE' },
    '/about/rentals': { id: 145, localeCode: 'en-GB' },
    '/fr/a-propos/location-art': { id: 145, localeCode: 'fr-FR' },
    '/kazoart': { id: 146, localeCode: 'en-GB' },
    '/fr/kazoart': { id: 146, localeCode: 'fr-FR' },
    '/glenfiddich/suspended-time': { id: 147, localeCode: 'en-GB' },
    '/glenfiddich/cumulative-time': { id: 148, localeCode: 'en-GB' },
    '/glenfiddich/simultaneous-time': { id: 149, localeCode: 'en-GB' },
    '/glenfiddich/gran-reserva': { id: 150, localeCode: 'en-GB' },
    '/glenfiddich/grand-cru': { id: 151, localeCode: 'en-GB' },
    '/glenfiddich/grande-couronne': { id: 152, localeCode: 'en-GB' },
    '/glenfiddich/grand-yozakura': { id: 153, localeCode: 'en-GB' },
    '/glenfiddich/grand-chateau': { id: 154, localeCode: 'en-GB' },
    '/exhibition/mitratabrizian': { id: 155, localeCode: 'en-GB' },
    '/fr/exposition/mitratabrizian': { id: 155, localeCode: 'fr-FR' },
    '/de/kataloge': { id: 156, localeCode: 'de-DE' },
    '/catalogues': { id: 156, localeCode: 'en-GB' },
    '/fr/catalogues': { id: 156, localeCode: 'fr-FR' },
    '/de/sohohome': { id: 157, localeCode: 'de-DE' },
    '/sohohome': { id: 157, localeCode: 'en-GB' },
    '/fr/sohohome': { id: 157, localeCode: 'fr-FR' },
    '/exhibition/reprise': { id: 158, localeCode: 'en-GB' },
  });
}
